import React from "react";

export const RetificacaoContext = React.createContext({
  dadosRetificacao: null,
  setDadosRetificacao: () => {},
});
